// In-memory stand-in for a future versions API (e.g. GET/POST /journeys/:key/versions).
// Call sites only deal with plain data in and plain data out, so swapping the body of
// each function for a real HTTP call later shouldn't require touching any caller.

const versionsByJourneyKey = {}
let nextId = 1

export function listVersions (journeyKey) {
  return versionsByJourneyKey[journeyKey] || []
}

export function latestVersionNumber (journeyKey) {
  const versions = listVersions(journeyKey)
  return versions.length ? versions[0].versionNumber : 0
}

export function createVersion (journeyKey, { notes, journeyJson }) {
  const existing = listVersions(journeyKey)
  const version = {
    id: nextId++,
    versionNumber: existing.length + 1,
    notes: (notes || '').trim(),
    createdAt: Date.now(),
    snapshot: JSON.parse(JSON.stringify(journeyJson))
  }
  versionsByJourneyKey[journeyKey] = [version, ...existing]
  return version
}

// A journey's dropdown key can change out from under its version history (e.g. an
// AI edit renames it, or the untitled draft gets its first real name) — carry the
// history over to the new key instead of losing it.
export function renameJourney (oldKey, newKey) {
  if (oldKey === newKey || !versionsByJourneyKey[oldKey] || versionsByJourneyKey[newKey]) return
  versionsByJourneyKey[newKey] = versionsByJourneyKey[oldKey]
  delete versionsByJourneyKey[oldKey]
}



// WEBPACK FOOTER //
// ./src/components/user-journey/journey-flow/journeyVersions.js